module.exports = __webpack_public_path__ + "static/media/success_payment.6501a3bf.svg";